import { FamaUtils } from "./classes/FamaUtils";
import { LibraryLoader } from "./classes/LibraryLoader";

let libraryLoader = LibraryLoader.getInstance();
let famautils = FamaUtils.getInstance();
